<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="common-header">
        <font style="vertical-align: inherit"
          ><font style="vertical-align: inherit"> {{ $t('mine.Personalinformation') }} </font></font
        >
      </div>
      <div class="info-content">
        <div class="info-content-hint">
          <font style="vertical-align: inherit"
            ><font style="vertical-align: inherit"> {{ $t('mine.Improving2') }}</font></font
          ><a href="javascript:void (0)" @click="$parent.openKefu" rel="noopener noreferrer" class="info-content-service"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('mine.Contact2') }}</font></font
            ></a
          >
        </div>
        <div class="ant-form ant-form-horizontal info-content-form">
          <div class="info-content-box">
            <span class="input-title"
              ><font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $t('mine.Username2') }}</font></font
              ></span
            >
            <input disabled="disabled" type="text" :value="$store.state.userInfo.username" class="ant-input ant-input-disabled enter-input" />
          </div>
          <div class="info-content-box">
            <span class="input-title"
              ><font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $t('mine.realname2') }}</font></font
              ></span
            >
            <input disabled="disabled" type="text" :value="$store.state.userInfo.realname" class="ant-input ant-input-disabled enter-input" />
          </div>

          <div class="ant-row ant-form-item">
            <div class="ant-col ant-form-item-label">
              <label for="weixin.contactValue"
                ><font style="vertical-align: inherit">
                  <font style="vertical-align: inherit">{{ $t('mine.Birthdate2') }}</font></font
                ></label
              >
            </div>
            <div class="ant-col ant-form-item-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content"><input type="text" v-model="birthday" class="ant-input enter-input" /></div>
              </div>
            </div>
          </div>
          <div class="ant-row ant-form-item">
            <div class="ant-col ant-form-item-label">
              <label for="weixin.contactValue"
                ><font style="vertical-align: inherit">
                  <font style="vertical-align: inherit">{{ $t('mine.Mailbox2') }}</font></font
                ></label
              >
            </div>
            <div class="ant-col ant-form-item-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content"><input type="text" v-model="email" class="ant-input enter-input" /></div>
              </div>
            </div>
          </div>
          <div class="ant-row ant-form-item">
            <div class="ant-col ant-form-item-label">
              <label for="weixin.contactValue"
                ><font style="vertical-align: inherit">
                  <font style="vertical-align: inherit">{{ $t('mine.Mobilenumber2') }}</font></font
                ></label
              >
            </div>
            <div class="ant-col ant-form-item-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content"><input type="text" v-model="mobile" class="ant-input enter-input" /></div>
              </div>
            </div>
          </div>
          <div class="ant-row ant-form-item">
            <div class="ant-col ant-form-item-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content">
                  <button class="ant-btn ant-btn-primary" @click="isOk">
                    <span
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Confirmation2') }}</font></font
                      ></span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="security-page">
        <div class="common-header">
          <font style="vertical-align: inherit">{{ $t('mine.SecurityCenter2') }}<font style="vertical-align: inherit; padding-left: 20px; font-size: 12px; color: #ccc"> V2.1.1.20220906_pc</font></font>
        </div>
        <div class="security-center-box">
          <ul class="security-list">
            <li class="security-li">
              <div class="security-icon">
                <svg width="1em" height="1em" viewBox="0 0 24 24">
                  <defs></defs>
                  <g id="safety_center_icon_user_svg__safety_center_icon_user" transform="translate(-324 -376)" style="fill: rgb(255, 255, 255)">
                    <g id="safety_center_icon_user_svg__\u7EC4_20" data-name="\u7EC4 20" opacity="0.5" style="fill: rgb(255, 255, 255)">
                      <path id="safety_center_icon_user_svg__\u77E9\u5F62_785" data-name="\u77E9\u5F62 785" transform="translate(324 376)" d="M0 0h24v24H0z" class="safety_center_icon_user_svg__cls-2"></path>
                    </g>
                    <g id="safety_center_icon_user_svg__\u7EC4_35" data-name="\u7EC4 35" transform="translate(4)">
                      <path id="safety_center_icon_user_svg__\u77E9\u5F62_65" data-name="\u77E9\u5F62 65" transform="translate(320 376)" opacity="0.549" fill="none" d="M0 0h24v24H0z"></path>
                      <g id="safety_center_icon_user_svg__\u7EC4_42" data-name="\u7EC4 42" transform="translate(-2 1)">
                        <g id="safety_center_icon_user_svg__\u692D\u5706_20" data-name="\u692D\u5706 20" transform="translate(326 378.5)" class="safety_center_icon_user_svg__cls-4">
                          <circle cx="6" cy="6" r="6" class="safety_center_icon_user_svg__cls-7"></circle>
                          <circle cx="6" cy="6" r="5" class="safety_center_icon_user_svg__cls-2"></circle>
                        </g>
                        <path id="safety_center_icon_user_svg__\u8DEF\u5F84_12" data-name="\u8DEF\u5F84 12" d="M325.141 395.002s2.816-4.507 6.832-4.5a6.817 6.817 0 013.216.93" stroke-linecap="round" stroke-width="2" stroke="#fff" fill="none"></path>
                      </g>
                      <g id="safety_center_icon_user_svg__\u7EC4_2611" data-name="\u7EC4 2611" transform="translate(3 3)">
                        <g id="safety_center_icon_user_svg__\u77E9\u5F62_53" data-name="\u77E9\u5F62 53" class="safety_center_icon_user_svg__cls-6">
                          <path d="M0 0h2v6H0z" transform="translate(335 383)" class="safety_center_icon_user_svg__cls-7"></path>
                          <path d="M.5.5h1v5h-1z" transform="translate(335 383)" class="safety_center_icon_user_svg__cls-2"></path>
                        </g>
                        <circle id="safety_center_icon_user_svg__\u692D\u5706_21" data-name="\u692D\u5706 21" cx="2" cy="2" r="2" transform="translate(334 389)" class="safety_center_icon_user_svg__cls-4"></circle>
                        <g id="safety_center_icon_user_svg__\u77E9\u5F62_54" data-name="\u77E9\u5F62 54" class="safety_center_icon_user_svg__cls-6">
                          <path d="M0 0h2v4H0z" transform="rotate(90 -23 362)" class="safety_center_icon_user_svg__cls-7"></path>
                          <path d="M.5.5h1v3h-1z" transform="rotate(90 -23 362)" class="safety_center_icon_user_svg__cls-2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="security-title">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.Modifylogin2') }} </font></font
                >
              </div>
              <div class="security-prompt">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.loginbeen2') }}</font></font
                >
              </div>
              <button type="button" class="ant-btn" @click="openpawShow">
                <span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('mine.Modify2') }} </font></font
                  ></span
                >
              </button>
            </li>
            <li class="security-li">
              <div class="security-icon">
                <svg width="1em" height="1em" viewBox="0 0 24 24">
                  <defs></defs>
                  <g id="safety_center_icon_safety_svg__safety_center_icon_safety" transform="translate(-324 -376)" style="fill: rgb(255, 255, 255)">
                    <g id="safety_center_icon_safety_svg__\u7EC4_20" data-name="\u7EC4 20" opacity="0.5" style="fill: rgb(255, 255, 255)">
                      <path id="safety_center_icon_safety_svg__\u77E9\u5F62_779" data-name="\u77E9\u5F62 779" transform="translate(324 376)" d="M0 0h24v24H0z" class="safety_center_icon_safety_svg__cls-2"></path>
                    </g>
                    <g id="safety_center_icon_safety_svg__\u7EC4_40" data-name="\u7EC4 40">
                      <path id="safety_center_icon_safety_svg__\u77E9\u5F62_66" data-name="\u77E9\u5F62 66" transform="translate(324 376)" opacity="0.549" fill="none" d="M0 0h24v24H0z"></path>
                      <g id="safety_center_icon_safety_svg__\u8DEF\u5F84_15" data-name="\u8DEF\u5F84 15" fill="none">
                        <path
                          d="M0 1A23.566 23.566 0 004.856.048 18.835 18.835 0 009-2 21.935 21.935 0 0013.277.048 23.108 23.108 0 0018 1v8a7.6 7.6 0 01-2.6 5.2S10.934 18 9 18c-2.088 0-6.4-3.8-6.4-3.8S0 11.883 0 9z"
                          transform="translate(327 380)"
                          class="safety_center_icon_safety_svg__cls-7"
                        ></path>
                        <path
                          d="M9.027.33c-.856.491-2.13 1.146-3.539 1.616-1.205.401-2.484.66-3.488.819V9c0 1.594 1.388 3.21 1.931 3.707.102.09 1.031.896 2.177 1.715 1.936 1.383 2.75 1.556 2.881 1.576.133-.026.936-.23 2.883-1.603a35.553 35.553 0 002.232-1.718h-.002l.014-.01C14.22 12.575 16 10.984 16 9V2.753c-.96-.16-2.179-.415-3.355-.807C11.23 1.474 9.91.816 9.027.33M9-2S11.027-.702 13.277.048 18 1 18 1v8c0 3.037-2.6 5.2-2.6 5.2S10.934 18 9 18c-2.088 0-6.4-3.8-6.4-3.8S0 11.883 0 9V1S2.606.798 4.856.048 9-2 9-2z"
                          fill="#fff"
                          transform="translate(327 380)"
                        ></path>
                      </g>
                      <g id="safety_center_icon_safety_svg__\u7EC4_2610" data-name="\u7EC4 2610">
                        <g id="safety_center_icon_safety_svg__\u77E9\u5F62_53" data-name="\u77E9\u5F62 53" class="safety_center_icon_safety_svg__cls-5">
                          <path d="M0 0h2v6H0z" transform="translate(335 383)" class="safety_center_icon_safety_svg__cls-7"></path>
                          <path d="M.5.5h1v5h-1z" transform="translate(335 383)" class="safety_center_icon_safety_svg__cls-2"></path>
                        </g>
                        <circle id="safety_center_icon_safety_svg__\u692D\u5706_21" data-name="\u692D\u5706 21" cx="2" cy="2" r="2" transform="translate(334 389)" stroke-width="2" stroke="#fff" fill="none"></circle>
                        <g id="safety_center_icon_safety_svg__\u77E9\u5F62_54" data-name="\u77E9\u5F62 54" class="safety_center_icon_safety_svg__cls-5">
                          <path d="M0 0h2v4H0z" transform="rotate(90 -23 362)" class="safety_center_icon_safety_svg__cls-7"></path>
                          <path d="M.5.5h1v3h-1z" transform="rotate(90 -23 362)" class="safety_center_icon_safety_svg__cls-2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="security-title">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.Changesecurity2') }} </font></font
                >
              </div>
              <div class="security-prompt">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.securitybeen2') }} </font></font
                >
              </div>
              <button type="button" class="ant-btn" @click="openpayPawShow">
                <span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('mine.Modify2') }}</font></font
                  ></span
                >
              </button>
            </li>
            <li class="security-li">
              <div class="security-icon">
                <svg width="1em" height="1em" viewBox="0 0 24 24">
                  <defs></defs>
                  <g id="safety_center_icon_safety_svg__safety_center_icon_safety" transform="translate(-324 -376)" style="fill: rgb(255, 255, 255)">
                    <g id="safety_center_icon_safety_svg__\u7EC4_20" data-name="\u7EC4 20" opacity="0.5" style="fill: rgb(255, 255, 255)">
                      <path id="safety_center_icon_safety_svg__\u77E9\u5F62_779" data-name="\u77E9\u5F62 779" transform="translate(324 376)" d="M0 0h24v24H0z" class="safety_center_icon_safety_svg__cls-2"></path>
                    </g>
                    <g id="safety_center_icon_safety_svg__\u7EC4_40" data-name="\u7EC4 40">
                      <path id="safety_center_icon_safety_svg__\u77E9\u5F62_66" data-name="\u77E9\u5F62 66" transform="translate(324 376)" opacity="0.549" fill="none" d="M0 0h24v24H0z"></path>
                      <g id="safety_center_icon_safety_svg__\u8DEF\u5F84_15" data-name="\u8DEF\u5F84 15" fill="none">
                        <path
                          d="M0 1A23.566 23.566 0 004.856.048 18.835 18.835 0 009-2 21.935 21.935 0 0013.277.048 23.108 23.108 0 0018 1v8a7.6 7.6 0 01-2.6 5.2S10.934 18 9 18c-2.088 0-6.4-3.8-6.4-3.8S0 11.883 0 9z"
                          transform="translate(327 380)"
                          class="safety_center_icon_safety_svg__cls-7"
                        ></path>
                        <path
                          d="M9.027.33c-.856.491-2.13 1.146-3.539 1.616-1.205.401-2.484.66-3.488.819V9c0 1.594 1.388 3.21 1.931 3.707.102.09 1.031.896 2.177 1.715 1.936 1.383 2.75 1.556 2.881 1.576.133-.026.936-.23 2.883-1.603a35.553 35.553 0 002.232-1.718h-.002l.014-.01C14.22 12.575 16 10.984 16 9V2.753c-.96-.16-2.179-.415-3.355-.807C11.23 1.474 9.91.816 9.027.33M9-2S11.027-.702 13.277.048 18 1 18 1v8c0 3.037-2.6 5.2-2.6 5.2S10.934 18 9 18c-2.088 0-6.4-3.8-6.4-3.8S0 11.883 0 9V1S2.606.798 4.856.048 9-2 9-2z"
                          fill="#fff"
                          transform="translate(327 380)"
                        ></path>
                      </g>
                      <g id="safety_center_icon_safety_svg__\u7EC4_2610" data-name="\u7EC4 2610">
                        <g id="safety_center_icon_safety_svg__\u77E9\u5F62_53" data-name="\u77E9\u5F62 53" class="safety_center_icon_safety_svg__cls-5">
                          <path d="M0 0h2v6H0z" transform="translate(335 383)" class="safety_center_icon_safety_svg__cls-7"></path>
                          <path d="M.5.5h1v5h-1z" transform="translate(335 383)" class="safety_center_icon_safety_svg__cls-2"></path>
                        </g>
                        <circle id="safety_center_icon_safety_svg__\u692D\u5706_21" data-name="\u692D\u5706 21" cx="2" cy="2" r="2" transform="translate(334 389)" stroke-width="2" stroke="#fff" fill="none"></circle>
                        <g id="safety_center_icon_safety_svg__\u77E9\u5F62_54" data-name="\u77E9\u5F62 54" class="safety_center_icon_safety_svg__cls-5">
                          <path d="M0 0h2v4H0z" transform="rotate(90 -23 362)" class="safety_center_icon_safety_svg__cls-7"></path>
                          <path d="M.5.5h1v3h-1z" transform="rotate(90 -23 362)" class="safety_center_icon_safety_svg__cls-2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="security-title">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.Proxyapplication') }} </font></font
                >
              </div>
              <div class="security-prompt">
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit"> {{ $t('mine.alreadyapplied2') }} </font></font
                >
              </div>
              <button type="button" class="ant-btn" @click="openapl">
                <span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('mine.Proxyapplication') }}</font></font
                  ></span
                >
              </button>
            </li>
          </ul>
        </div>
      </div>
      <!--修改登陆密码-->
      <div id="editpass" v-if="pawShow">
        <div class="login_mask"></div>
        <div class="tc-login">
          <div class="tc-main">
            <div class="login_close" @click="close"></div>
            <h1 class="tc-title">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $t('mine.Modifylogin2') }}</font></font
              >
            </h1>
            <div>
              <div class="in-box"><input v-model="passwordInfo.password" type="password" tabindex="6" maxlength="12" :placeholder="$t('mine.enteroriginal2')" autocomplete="off" class="in-mm" /></div>
              <div class="in-box"><input v-model="passwordInfo.paypassword" type="password" tabindex="6" maxlength="12" :placeholder="$t('mine.enternew2')" autocomplete="off" class="in-mm" /></div>
              <div class="in-box"><input v-model="passwordInfo.newpasword" type="password" tabindex="6" maxlength="12" :placeholder="$t('mine.newenter2')" autocomplete="off" class="in-mm" /></div>
              <div class="tc-anniu">
                <a href="javascript:;" @click="editPassword(1)" title="" class="tc-but tc-dl"
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('mine.Modify2') }}</font></font
                  ></a
                >
              </div>
              <div class="in-box" style="height: 30px"></div>
            </div>
          </div>
        </div>
      </div>
      <!--修改支付密码-->
      <div id="editpass" v-if="payPawShow">
        <div class="login_mask"></div>
        <div class="tc-login">
          <div class="tc-main">
            <div class="login_close" @click="close"></div>
            <h1 class="tc-title">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $t('mine.Changesecurity2') }}</font></font
              >
            </h1>
            <div>
              <div class="in-box"><input v-model="passwordInfo.password" type="password" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" :placeholder="$t('mine.enteroriginal2')" autocomplete="off" class="in-mm" /></div>
              <div class="in-box"><input v-model="passwordInfo.paypassword" type="password" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" :placeholder="$t('mine.enternew2')" autocomplete="off" class="in-mm" /></div>
              <div class="in-box"><input v-model="passwordInfo.newpasword" type="password" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" :placeholder="$t('mine.newenter2')" autocomplete="off" class="in-mm" /></div>
              <div class="tc-anniu">
                <a href="javascript:;" @click="editPassword(2)" title="" class="tc-but tc-dl"
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('mine.Modify2') }}</font></font
                  ></a
                >
              </div>
              <div class="in-box" style="height: 30px"></div>
            </div>
          </div>
        </div>
      </div>
      <!--申请代理-->
      <div id="editpass" v-if="apl">
        <div class="login_mask"></div>
        <div class="tc-login">
          <div class="tc-main">
            <div class="login_close" @click="close"></div>
            <h1 class="tc-title">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $t('mine.Proxyapplication') }}</font></font
              >
            </h1>
            <div>
              <div class="in-box"><input type="text" :value="$store.state.userInfo.realname" :placeholder="$t('mine.yourname2')" disabled class="in-mm ant-input-disabled" /></div>
              <div class="in-box"><input type="text" tabindex="6" v-model="info.mobile" maxlength="11" :placeholder="$t('mine.Mobilenumber2')" autocomplete="off" class="in-mm" /></div>
              <div class="in-box"><input type="text" v-model="info.apply_info" maxlength="12" :placeholder="$t('mine.enterreason2')" autocomplete="off" class="in-mm" /></div>
              <div class="tc-anniu">
                <a href="javascript:;" @click="shenqing" title="" class="tc-but tc-dl"
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('mine.Modify2') }}</font></font
                  ></a
                >
              </div>
              <div class="in-box" style="height: 30px"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'center',
  data() {
    return {
      mobile: null,
      email: null,
      birthday: null,
      passwordInfo: {},
      info: {},
      baseURL: '',
      pawShow: false,
      payPawShow: false,
      apl: false,
    };
  },
  created() {
    let that = this;
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    that.mobile = userInfo.mobile;
    that.email = userInfo.email;
    that.birthday = userInfo.birthday;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    shenqing() {
      let that = this;
      that.birthday = $('.ant-picker-input').html();
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.showTost(0, that.$t('mine.enterphoneenter2'));
        return;
      }

      if (!info.apply_info) {
        that.showTost(0, that.$t('mine.enterapplication2'));
        return;
      }
      that.close();

      that.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.showTost(1, res.message);
          that.hideLoading();
          that.info = {};
          that.clreaInfo();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    editPassword(pasType) {
      let that = this;
      if (!that.passwordInfo.password) {
        that.$parent.showTost(0, that.$t('mine.enterold2'));
        return;
      }
      if (!that.passwordInfo.paypassword) {
        that.$parent.showTost(0, that.$t('mine.enternewpassword2'));
        return;
      }
      if (that.passwordInfo.password.length < 6) {
        that.$parent.showTost(0, that.$t('mine.enterpasswordlength2'));
        return;
      }
      if (that.passwordInfo.paypassword.length < 6) {
        that.$parent.showTost(0, that.$t('mine.entercorrect2'));
        return;
      }
      if (!that.passwordInfo.newpasword) {
        that.$parent.showTost(0, that.$t('mine.enterconfirmation2'));
        return;
      }
      if (that.passwordInfo.newpasword != that.passwordInfo.paypassword) {
        that.$parent.showTost(0, that.$t('mine.passwordstwo2'));
        return;
      }
      if (that.passwordInfo.password == that.passwordInfo.paypassword) {
        that.$parent.showTost(0, that.$t('mine.oldnew2'));
        that.passwordInfo = {};
        return;
      }
      let url = pasType == 1 ? '/api/editPassword' : '/api/editPayPassword';

      that.$parent.showLoading();
      that.$apiFun.post(url, that.passwordInfo).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, that.$t('mine.changed2'));
          that.passwordInfo = {};
          that.clreaInfo();
          that.close();
          if (pasType == 1) {
            sessionStorage.setItem('token', '');
            //  that.$cookies.remove('token' )
            that.$store.commit('changToken');
            that.$router.push({ path: '/login' });
          }
        }
      });
    },
    isOk() {
      let that = this;
      let info = { email: that.email, mobile: that.mobile, birthday: that.birthday };
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let dateFormat = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, that.$t('mine.enterphoneenter2'));
        return;
      }
      if (!regEmail.test(that.email)) {
        that.$parent.showTost(0, that.$t('mine.enteremail2'));
        return;
      }
      if (!dateFormat.test(that.birthday)) {
        that.$parent.showTost(0, that.$t('mine.entercorrect2w'));
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/updateuserinfo', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.mobile = info.mobile;
            userInfo.email = info.email;
            userInfo.birthday = info.birthday;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$parent.getUserInfo();
            that.$parent.showTost(1, that.$t('mine.Successful'));
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    close() {
      let that = this;
      that.pawShow = false;
      that.payPawShow = false;
      that.apl = false;
      that.info = {};
      that.passwordInfo = {};
    },
    openpawShow() {
      let that = this;
      this.pawShow = true;
      that.info = {};
      that.passwordInfo = {};
    },
    openpayPawShow() {
      let that = this;

      this.payPawShow = true;
      that.info = {};
      that.passwordInfo = {};
    },
    openapl() {
      let that = this;

      this.apl = true;
      that.info = {};
      that.passwordInfo = {};
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    goNav(url) {
      this.$parent.goNav(url);
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/info.css';
@import '../../../static/css/security.css';
@import '../../../static/css/index.c63a72ee.css';
@import '../../../static/css/main.2ffd799a.css';
@import '../../../static/css/vendor6e8de9f2.8d5aa1ea.css';
@import '../../../static/css/stylelogin.css';

@import '../../../static/css/vendor87e02e73.b19a75e1.css';

.in-box .checkbox {
  display: block;
  float: left;
  margin: 0 auto;
  width: 125px;
  height: 38px;
  line-height: 38px;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: #333;
  text-indent: 25px;
  font-size: 13px;
  box-sizing: content-box;
  padding-left: 2px;
}
.login_close {
  display: inline-block;

  float: right;

  width: 22px;

  height: 20px;
  margin: 6px 6px;
  background: url(/static/image/modal-close.png) no-repeat 0 0px;

  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/center.vue